import React from "react";

interface ProgressBarProps {
  percentage: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ percentage }) => {
  return (
    <div className="w-full progress-bar bg-slate-600 h-4 overflow-hidden rounded-full">
      <div
        className="progress-bar-inner bg-gbci-primary h-full transition-all"
        style={{ width: `${percentage}%` }}
      ></div>
    </div>
  );
};

export default ProgressBar;
